import fetch from '@/utils/fetch';
var loadObj;
var MODAL_ACTIVE = false; // Modal是否已经生成
var scrollTop = 0; // 文档滚动距离

/**
 * 获取url中的查询参数
 * @param {String} name URL中的参数名
 */
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);

  if (r != null) {
    return unescape(r[2]);
  }

  return null;
}

/**
 * 显示loading
 * @param {title} opt.title loading文本
 */
export function showLoading (opt) {
  try {
    if (!opt || !opt.title) throw new Error('title is undefined');

    loadObj = document.createElement('div');
    var AniObj = document.createElement('div');
    var TextObj = document.createElement('p');

    loadObj.className = 'loading';
    AniObj.className = 'loading-circle';
    TextObj.className = 'loading-text';
    TextObj.innerText = opt.title;

    for (var i = 0, j = 12; i < j; i++) {
      var itemObj = document.createElement('div');
      itemObj.className = 'circle-child circle' + (i + 1);
      AniObj.appendChild(itemObj);
    }

    loadObj.appendChild(AniObj);
    loadObj.appendChild(TextObj);

    document.querySelector('body').appendChild(loadObj);
  } catch (err) {
    console.error(err);
  }
}

/**
 * 关闭loading
 */
export function hideLoading () {
  loadObj.remove();
}

/**
 * 显示模态框
 * @param {String} opt.title 标题
 * @param {String} opt.content 内容
 * @param {Boolean} opt.showCance 是否显示取消按钮
 * @param {String} opt.confirmText 确认按钮的文本信息
 * @param {String} opt.confirmColor 确认按钮的文本颜色
 */
export function showModal (opt) {
  if (MODAL_ACTIVE) return;

  var modalBg = document.createElement('div');
  var modalBox = document.createElement('div');
  var modalTitle = document.createElement('div');
  var modalBody = document.createElement('div');
  var modalFoot = document.createElement('div');
  var confirm = document.createElement('span');  // 确定按钮
  var cancel = document.createElement('span');   // 取消按钮

  modalBg.id = 'modalBg';
  modalBg.className = 'modal-bg';
  modalBox.className = 'modal';

  // 标题
  modalTitle.className = 'modal-title';
  modalTitle.innerText = opt.title;
  modalBox.appendChild(modalTitle);

  // 内容
  modalBody.className = 'modal-body';
  modalBody.innerText = opt.content;
  modalBox.appendChild(modalBody);

  modalFoot.className = 'modal-foot';

  // 取消按钮
  if (opt.showCance) {
    cancel.className = 'btn';
    cancel.innerText = opt.cancelText || '取消';
    cancel.style.color = opt.cancelColor || '#000000';
    cancel.addEventListener('touchstart', function (e) {
      opt.fail(this);
      e.preventDefault() && e.stopPropagation(); // 禁止事件冒泡
    });

    modalFoot.appendChild(cancel);
  }

  // 确定按钮
  confirm.className = 'btn';
  confirm.innerText = opt.confirmText || '确定';
  confirm.style.color = opt.confirmColor || '#3CC51F';
  confirm.addEventListener('touchstart', function (e) {
    opt.success(this);
    e.preventDefault() && e.stopPropagation(); // 禁止事件冒泡
  });

  modalFoot.appendChild(confirm);
  modalBox.appendChild(modalFoot);

  var body = document.querySelector('body');

  // 解决滚动穿透
  scrollTop = document.body.scrollTop || document.documentElement.scrollTop; // 记录已滚动的距离
  if (scrollTop !== 0) {
    body.classList.add('dialog-open');
    //body.style.top = -scrollTop + 'px';
  }

  body.appendChild(modalBg);
  body.appendChild(modalBox);

  MODAL_ACTIVE = true;
}

/**
 * 关闭模态框
 * @param {Document} event 按钮对象
 */
export function hideModal (event) {
  var body = document.querySelector('body');

  // 解决滚动穿透的问题
  body.classList.remove('dialog-open');
  body.scrollTop = scrollTop;

  document.getElementById('modalBg').remove();
  body.removeChild(event.parentNode.parentNode);

  MODAL_ACTIVE = false;
}

/**
 * Toast
 * @param {String} opt.message 内容
 * @param {String} opt.image 图片路径
 * @param {String} opt.duration 延时关闭的时间 毫秒
 */
export function showToast (opt) {
  var ToastObj = document.createElement('div');
  var ToastBoxObj = document.createElement('div');
  var TextObj = document.createElement('p');

  if (opt.image) {
    var ImgObj = new Image();

    ImgObj.src = opt.image;
    ImgObj.className = 'toast-img';
    ToastBoxObj.appendChild(ImgObj);
  }

  ToastObj.className = 'h5-toast';
  ToastBoxObj.className = 'h5-toast-box';
  TextObj.className = 'toast-des';
  TextObj.innerText = opt.message;

  ToastBoxObj.appendChild(TextObj);
  ToastObj.appendChild(ToastBoxObj);

  document.querySelector('body').appendChild(ToastObj);

  var clock = setTimeout(function () {
    clearTimeout(clock);
    ToastObj.remove();
  }, opt.duration);
}

// 修改网页标题
export function setHtmlTitle(title) {
  document.querySelector("body").setAttribute("style", "position:static");
  document.getElementsByTagName('title')[0].innerText = title;
}


// 增加页面访问记录
export function pageRecord(subCode) {
  let param={
      subCode: subCode
    }
  fetch.post('/wxyx/addPageRecord',{
    subCode: subCode
  }).then((res)=>{
    console.log("访问成功");
  },(err) => {
    showToast({
      message: err.error_info || err.message,
      duration: 2000
    })
  });
}

